import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import { loadState, saveState, clearState } from './storage';
import { reset } from '../components/views/chat/actions';
import { resetConfig } from './configuration/actions';
import { VIEWS } from '../components/views/types';
import Logger from '../../common/logger';

// redux middlewares
const middlewares = [];
middlewares.push(thunk);

// dev logging
if (process.env.NODE_ENV !== 'production') {
    const { logger } = require('redux-logger');
    middlewares.push(logger);
}

const VIEWS_TO_RESTORE = [VIEWS.CHAT, VIEWS.CHAT_SAVE, VIEWS.QUESTIONNAIRE];

// redux presistance
let persistedState = loadState();
if (
    persistedState &&
    (!persistedState.widget ||
        !persistedState.widget.currentView ||
        VIEWS_TO_RESTORE.indexOf(persistedState.widget.currentView) === -1)
) {
    // don't restore on contact or cmb
    persistedState = {};
    clearState();
}
const store = createStore(reducers, persistedState, applyMiddleware(...middlewares));

// monitor and save app state
let lastView = null;
store.subscribe(() => {
    const state = store.getState();
    if (
        lastView !== null &&
        state.widget.currentView !== lastView &&
        state.widget.currentView === null
    ) {
        Logger.log(
            `Store.reset [widget.currentView=${state.widget.currentView}, lastView=${lastView}]`
        );
        setTimeout(() => {
            Logger.log('Store.reseting...');
            store.dispatch(reset());
            resetConfig();
            clearState();
        }, 500);
    } else {
        if (state.widget.currentView) {
            saveState(store.getState());
        } else {
            clearState();
        }
    }

    lastView = state.widget.currentView;
});

export default store;
